import React, { useState } from "react";
import {
  Card,
  CardBody,
  Row,
  Col,
  Button,
  ButtonGroup,
} from "reactstrap";
import { useHistory } from "react-router-dom";
import { useMutation, useQuery } from "@apollo/client";
import Alert from "react-bootstrap/Alert";
import { toast } from "react-toastify";
import {
  HOSPITAL_DELETE_MUTATION,
  HOSPITAL_DETAIL_QUERY,
  HOSPITAL_LIST_QUERY,
} from "../../config/Queries";

function HospitalView({ match }) {
  const id = parseInt(match.params.id, 10);
  const history = useHistory();
  const [showAlert, setShowAlert] = useState(false);
  const { data, loading } = useQuery(HOSPITAL_DETAIL_QUERY, {
    variables: { id },
  });
  const [deleteHospital] = useMutation(HOSPITAL_DELETE_MUTATION, {
    variables: { id },
    refetchQueries: [{ query: HOSPITAL_LIST_QUERY }],
  });

  const hospital = data?.viewHospital;
  const images = hospital?.images
    ? hospital.images.split("|").filter(Boolean)
    : [];

  const onDeleteClick = async () => {
    try {
      const {
        data: { deleteHospital: result },
      } = await deleteHospital();

      if (!result?.ok) {
        toast.error(result?.error || "병원 삭제에 실패했습니다.");
        return;
      }

      toast.success("병원 삭제가 완료되었습니다.");
      history.push("/admin/hospitals");
    } catch (e) {
      console.log(e);
      toast.error("병원 삭제 중 오류가 발생했습니다.");
    }
  };

  if (loading) {
    return null;
  }

  return (
    <div className="content">
      <Card>
        <div className="card-heading">{hospital?.name}</div>
        <CardBody>
          <Row className="m-b-15">
            <Col md="3">
              <strong>병원명</strong>
              <div>{hospital?.name || "-"}</div>
            </Col>
            <Col md="3">
              <strong>전화번호</strong>
              <div>{hospital?.phone || "-"}</div>
            </Col>
            <Col md="6">
              <strong>주소</strong>
              <div>{hospital?.address || "-"}</div>
            </Col>
          </Row>
          <Row className="m-b-15">
            <Col md="6">
              <strong>태그</strong>
              <div>{hospital?.tags || "-"}</div>
            </Col>
            <Col md="3">
              <strong>위도</strong>
              <div>{hospital?.latitude ?? "-"}</div>
            </Col>
            <Col md="3">
              <strong>경도</strong>
              <div>{hospital?.longitude ?? "-"}</div>
            </Col>
          </Row>
          <Row className="m-b-15">
            <Col md="12">
              <strong>인사말</strong>
              <div style={{ whiteSpace: "pre-wrap" }}>
                {hospital?.greeting || "-"}
              </div>
            </Col>
          </Row>
          <Row className="m-b-15">
            <Col md="12">
              <strong>로고</strong>
              {hospital?.logo ? (
                <div className="m-t-10">
                  <img
                    src={hospital.logo}
                    alt={hospital.name}
                    style={{
                      width: 160,
                      height: 160,
                      objectFit: "cover",
                      borderRadius: 4,
                    }}
                  />
                </div>
              ) : (
                <div>-</div>
              )}
            </Col>
          </Row>
          <Row>
            <Col md="12">
              <strong>병원 사진</strong>
              {images.length > 0 ? (
                <Row className="m-t-10">
                  {images.map((imageUrl) => (
                    <Col xs={6} md={3} key={imageUrl} className="m-b-10">
                      <img
                        src={imageUrl}
                        alt="병원 사진"
                        style={{
                          width: "100%",
                          height: 140,
                          objectFit: "cover",
                          borderRadius: 4,
                        }}
                      />
                    </Col>
                  ))}
                </Row>
              ) : (
                <div>-</div>
              )}
            </Col>
          </Row>
        </CardBody>
      </Card>
      <Row>
        <Col xs="6" className="text-left">
          <Button
            className="btn-white"
            onClick={() => history.push("/admin/hospitals")}
          >
            <i className="fa fa-list"></i> 목록
          </Button>
        </Col>
        <Col xs="6" className="text-right">
          <ButtonGroup>
            <Button
              className="btn-white text-success"
              onClick={() => history.push(`/admin/hospitals/${id}/edit`)}
            >
              <i className="fas fa-edit"></i> 수정
            </Button>
            <Button
              className="btn-white text-danger"
              onClick={() => setShowAlert(true)}
            >
              <i className="fas fa-trash"></i> 삭제
            </Button>
          </ButtonGroup>
        </Col>
      </Row>
      {showAlert && (
        <Alert variant="danger">
          <Alert.Heading>병원을 삭제하시겠습니까?</Alert.Heading>
          <p>삭제된 병원 정보와 이미지는 복구할 수 없습니다.</p>
          <hr />
          <div className="d-flex justify-content-end">
            <Button onClick={onDeleteClick} variant="outline-success">
              삭제
            </Button>
            <Button
              onClick={() => setShowAlert(false)}
              variant="outline-success"
            >
              취소
            </Button>
          </div>
        </Alert>
      )}
    </div>
  );
}

export default HospitalView;
